import { apiUrl } from 'util/apiUrl';
import { Error } from 'models/Error';
import { useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { OrganizationResponseModelPaginatedList } from 'types/api';
import {
  ContentType,
  useAuthenticatedFetch,
} from 'hooks/util/useAuthenticatedFetch';

export const useOrganization = (
  includeUsers = false,
  removeOrganizationHeader = false,
  enabled = true,
) => {
  const fetch = useAuthenticatedFetch(
    removeOrganizationHeader
      ? ContentType.NO_ORGANIZATION_HEADER
      : ContentType.APPLICATIONJSON,
  );

  return useQuery<OrganizationResponseModelPaginatedList, Error>(
    ['organizations'],
    () =>
      fetch(
        `${apiUrl}/Organizations?includeUsers=${includeUsers}`,
      ),
    {
      enabled,
      onError: () => {
        toast.error('Error fetching organizations.');
      },
    },
  );
};
